import React from 'react';
import './print_styles.scss';

const TechnicalIncidentsPrint = React.forwardRef(({ headers, rows = [] }, ref) => {
  return (
    <>
      <div className="print_report" ref={ref} key="technical-incidents-print">
        <h1>INCIDENTES TÉCNICOS</h1>
        <br />
        <table className="table-print">
          <thead>
            <tr>
              {headers &&
                headers.map(head => (
                  <React.Fragment key={head.name}>
                    {head.name !== 'ACCIONES' && (
                      <td width={`${head.grow * 100}px`} style={{ ...head.style }}>
                        {head.name}
                      </td>
                    )}
                  </React.Fragment>
                ))}
            </tr>
          </thead>
          <tbody>
            {rows &&
              rows.map(row => (
                <tr key={`${row.id}`}>
                  <td>{row.parsed_start_date}</td>
                  <td>{row.parsed_end_date}</td>
                  <td>{row.incident}</td>
                  <td>{row.parsed_created_at}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
});

export default TechnicalIncidentsPrint;
